module.exports = __webpack_public_path__ + "img/standby.441b25c5.png";